import InlineTable from '../primitives/InlineTable';
import { buildBreadcrumb } from '../lib/breadcrumbFormat';
import {
    buildColumns,
    buildRows,
    parentName,
    pinnedTitleParts,
} from '../lib/tableHelpers';
import type { TableModel, VisualProps, VisualWidget } from '../types';

const NAME_KEY = 'category_name';
const TYPE_LABEL = 'Category';

/** `category_list_inline_table` — an anchor-less list of specific categories
 * (any depth below cat1). */
function buildCategoryListTableModel({
    input,
    output,
    title: customTitle,
}: VisualProps): TableModel {
    const columns = buildColumns(input?.order_by);
    return {
        breadcrumb: buildBreadcrumb(output, TYPE_LABEL),
        title: {
            custom: customTitle || undefined,
            parent: parentName(output),
            noun: 'categories',
            ...pinnedTitleParts(output, NAME_KEY),
            lifeCycle: input?.life_cycle,
        },
        link: output?.result?.dashboard_url,
        nameColumnHeader: 'Category',
        columns,
        rows: buildRows(output, columns, NAME_KEY),
    };
}

const CategoryListInlineTable = ({ Frame, dense, ...props }: VisualProps) => (
    <InlineTable
        {...buildCategoryListTableModel(props)}
        Frame={Frame}
        dense={dense}
    />
);

const widget: VisualWidget = {
    match: (input) =>
        (input?.data_source ?? 'pop_index') === 'pop_index' &&
        input?.entity_relationship === 'categories' &&
        !input?.entity_type &&
        input?.entity_index == null &&
        !input?.entity_id &&
        // Chart-view lists render their charts (disjoint REGISTRY matches).
        !input?.aggregate &&
        !input?.trend_lines,
    Component: CategoryListInlineTable,
};

export default widget;
